import React, {useState, useEffect, useContext, Suspense, lazy} from 'react';
import Axios from 'axios';
import _ from "lodash";

import {LPHandlerProvider, LPHandlerContext} from './context/LPHandlerProvider'

import TempSelector from "./temps/TempSelector";

//import TagManager from 'react-gtm-module';

// Hide all Warning logs in console
const ActualWarn = console.warn;
const ActualError = console.error;

console.warn = (...args) => {
  if (args[0]?.toString().includes("Warning")) return;
  ActualWarn(...args);
};

console.error = (...args) => {
  if (args[0]?.toString().includes("Warning")) return;
  ActualError(...args);
};
// Hide all Warning logs in console


var slugv = "";
if (window.location.pathname.length > 0) {
    slugv = window.location.pathname;
    slugv = slugv.substr(slugv.lastIndexOf('/') + 1);
}

let domain = window.location.host;
	
if(domain === 'frontend.convertbrite.com'){
	let url_params = new URL(window.location.href);
	const orgDomain =  url_params.searchParams.get("domain");
	const orgSlug =  url_params.searchParams.get("slug");
	
	domain = orgDomain;
	slugv = orgSlug;
}
	
const dataVals = {
    domain: domain,
    slug: slugv
};

const slugT = window.location.pathname;
const slugTR = slugT.substr(slugT.lastIndexOf('/') + 1);

const slugarr = window.location.pathname.substr(1).split("/");


// Switch body classes based on the Window Size (Desktop and Mobile)
const media = window.matchMedia("(max-width: 991px)");

function handleChange(e) {
  if (e.matches) {
    document.body.classList.add("cbmobile-view");
    document.body.classList.remove("cbdesktop-view");
  } else {
    document.body.classList.add("cbdesktop-view");
    document.body.classList.remove("cbmobile-view");
  }
}

handleChange(media);
media.addEventListener("change", handleChange);



const App = () => {
	
    const [client_id, setClientId] = useState(0);
    const [temp_name, setTempName] = useState("");
    const [lp_id, setLPId] = useState(0);
	const [widget_temps, setWidgetTemps] = useState(0);
	const [gaCode, setGaCode] = useState('');
	
    useEffect(() => {
	
		//console.log(dataVals);

        const urlParams = new URLSearchParams(window.location.search);
        const loggedInParam = urlParams.get("loggedin");

        if (loggedInParam === "true") {
            const isLoggedIn = localStorage.getItem("front_loggedin");
            if (!isLoggedIn) {
                window.location.href = "/login"; // Redirect to /login
                return;
            }
        }

        if (slugTR === 'login') {
            let temp_name = 'Login';
			setTempName(temp_name);
			
        } else {
			
            Axios.post(window.apiPath + 'get_ws_info', dataVals, window.configJson, {withCredentials: true})
            .then(response => {
                //check response of App.js
				//console.log(response);

                if (response.data) {
					
                    localStorage.setItem("client_id", JSON.stringify(response.data.client_id));
                    localStorage.setItem("temp_name", JSON.stringify(_.shuffle(response.data.lp_selected_temps)[0]));
                    localStorage.setItem("lp_id", JSON.stringify(response.data.lp_id));
					localStorage.setItem("widget_temps", JSON.stringify(response.data.lp_selected_widget_temps));
                    localStorage.setItem("pg_type", JSON.stringify(response.data.pg_type));

                    let temp_name = "";
                    if (slugTR === 'login') {
                        temp_name = 'Login';
                    } else if (slugTR === 'contactme') {
                        temp_name = 'Contact_Card';
                    } else {
                        temp_name = _.shuffle(response.data.lp_selected_temps)[0];
                    }

                    setTempName(temp_name);
                    setLPId(response.data.lp_id);
                    setClientId(response.data.client_id);
					
                    setGaCode(response.data.ga_code);
					
					if (response.data.lp_selected_widget_temps && response.data.lp_selected_widget_temps.length) {
						setWidgetTemps(parseInt(response.data.lp_selected_widget_temps.toString()));
					}
					
					
					//TagManager.initialize({ gtmId: "GTM-" + response.data.ga_code });
				
                }
            })
            .catch(error => {
                console.log(error.response);
            });
        }

    }, []);
	
	// useEffect(() => {
	// 	//console.log("GTM-" + gaCode);
	// 	TagManager.initialize({ gtmId: gaCode });
    //     window.dataLayer = window.dataLayer || [];
    //     window.gtag = function () { window.dataLayer.push(arguments); };
    //     window.gtag('js', new Date());
    //     window.gtag('config', gaCode);
	// 	//console.log('gaCode is:', gaCode);

	// }, [gaCode]);
    
    // GA4 Custom code for tracking and "gaCode" is managing dynamically
    useEffect(() => {
        if (!gaCode) return;
        const existingScript = document.getElementById('gtag-script');
        if (existingScript) {
            existingScript.remove();
        }
        const script = document.createElement('script');
        script.id = 'gtag-script';
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${gaCode}`;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        window.gtag = function () { window.dataLayer.push(arguments); };
        window.gtag('js', new Date());
        window.gtag('config', gaCode);
    }, [gaCode]);
	
   if (temp_name === '') {
        return (
            <Suspense fallback={<div className="App">Loading...</div>}></Suspense>
        );
    } else {
        return (
            <Suspense fallback={<div className="App"></div>}>
                <div className="App">
                    <LPHandlerProvider>
                        <TempSelector />
                    </LPHandlerProvider>
                </div>
            </Suspense>
        );
   }
}

export default App;
